const DEFAULT_REDIRECT = '/';

/**
 * Проверяет и возвращает безопасный внутренний путь для редиректа после логина.
 * Блокирует open redirect (внешние URL, protocol-relative пути).
 */
export function getSafeRedirectPath(
  redirect: string | null | undefined,
  fallback = DEFAULT_REDIRECT,
): string {
  if (!redirect) {
    return fallback;
  }

  if (!redirect.startsWith('/')) {
    return fallback;
  }

  if (redirect.startsWith('//')) {
    return fallback;
  }

  if (redirect.startsWith('/login')) {
    return fallback;
  }

  return redirect;
}
